import React from "react";
import { Button, Modal } from "react-bootstrap";

const FileViewer = ({ renderFileContent, onClose, showModal }) => {
  return (
    <Modal
      show={showModal}
      onHide={() => {
        onClose();
      }}
      size="lg"
      backdrop="static"
      keyboard={false}
      className="modal-dialog-centered"
    >
      <Modal.Header className="bg-gray-200 border-b border-gray-300">
        <Modal.Title className="text-lg font-semibold">File Viewer</Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-6 overflow-auto">
        {renderFileContent()}
      </Modal.Body>
      <Modal.Footer className="bg-gray-200 border-t border-gray-300 flex justify-end">
        <Button
          variant="secondary"
          onClick={() => {
            onClose();
          }}
        >
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default FileViewer;
